/* tslint:disable */
/* eslint-disable */
/**
 * Melco Reporting APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportingMelcoMachineStatisticsModelsStatisticsListFilter,
    ReportingMelcoMachineStatisticsModelsStatisticsListFilterFromJSON,
    ReportingMelcoMachineStatisticsModelsStatisticsListFilterFromJSONTyped,
    ReportingMelcoMachineStatisticsModelsStatisticsListFilterToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReportingMelcoMachineStatisticsModelsUpdateFilter
 */
export interface ReportingMelcoMachineStatisticsModelsUpdateFilter {
    /**
     * 
     * @type {string}
     * @memberof ReportingMelcoMachineStatisticsModelsUpdateFilter
     */
    screenName?: string | null;
    /**
     * 
     * @type {ReportingMelcoMachineStatisticsModelsStatisticsListFilter}
     * @memberof ReportingMelcoMachineStatisticsModelsUpdateFilter
     */
    filtersData?: ReportingMelcoMachineStatisticsModelsStatisticsListFilter;
}

export function ReportingMelcoMachineStatisticsModelsUpdateFilterFromJSON(json: any): ReportingMelcoMachineStatisticsModelsUpdateFilter {
    return ReportingMelcoMachineStatisticsModelsUpdateFilterFromJSONTyped(json, false);
}

export function ReportingMelcoMachineStatisticsModelsUpdateFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportingMelcoMachineStatisticsModelsUpdateFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'screenName': !exists(json, 'screenName') ? undefined : json['screenName'],
        'filtersData': !exists(json, 'filtersData') ? undefined : ReportingMelcoMachineStatisticsModelsStatisticsListFilterFromJSON(json['filtersData']),
    };
}

export function ReportingMelcoMachineStatisticsModelsUpdateFilterToJSON(value?: ReportingMelcoMachineStatisticsModelsUpdateFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'screenName': value.screenName,
        'filtersData': ReportingMelcoMachineStatisticsModelsStatisticsListFilterToJSON(value.filtersData),
    };
}


